import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const fetchStatus = createAsyncThunk(
  "status/fetchStatus",
  async (_, { getState }) => {
    const { status } = getState().status;
    if (status.length > 0) {
      return status;
    }
    const response = await axiosInstance.get("/status");
    return response.data;
  }
);

export const addStatus = createAsyncThunk("status/addStatus", async (newStatus, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post("/status", { newStatus });
    return response.data;
  } catch (error) {
    console.error("Error adding status:", error);
    return rejectWithValue(error.response?.data || "Error adding status");
  }
});

export const updateStatus = createAsyncThunk("status/updateStatus", async ({ id, newStatus }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/status/${id}`, { newStatus });
    return response.data;
  } catch (error) {
    console.error("Error updating status:", error);
    return rejectWithValue(error.response?.data || "Error updating status");
  }
});

export const deleteStatus = createAsyncThunk("status/deleteStatus", async (id, { rejectWithValue }) => {
  try {
    await axiosInstance.delete(`/status/${id}`);
    return id; // Return ID to remove from state
  } catch (error) {
    console.error("Error deleting status:", error);
    return rejectWithValue(error.response?.data || "Error deleting status");
  }
});

const statusSlice = createSlice({
  name: "status",
  initialState: {
    status: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload;
      })
      .addCase(fetchStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status.push(action.payload);
      })
      .addCase(addStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.status.findIndex((status) => status.id === action.payload.id);
        if (index !== -1) {
          state.status[index] = action.payload;
        }
      })
      .addCase(updateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = state.status.filter((status) => status.id !== action.payload);
      })
      .addCase(deleteStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default statusSlice.reducer;
